import React from "react";
import { Row, Col, Container } from "react-bootstrap";

const Step9 = ({ text, formToShow }) => {
  // Helper function to render a section if its step is activated
  const renderSection = (title, content, stepIndex) => {
    // If stepIndex is provided and formToShow exists, check if that step is activated
    if (stepIndex !== undefined && formToShow) {
      const stepItem = formToShow.find((item) => item.Index === stepIndex);

      // Skip this section if the step is not activated
      if (!stepItem || !stepItem.IsActivated) {
        return null;
      }
    }

    // Always render the section if the step is activated, even if content is empty
    return (
      <div className="mb-3">
        <h5>{title}</h5>
        <div className="pl-3">{content}</div>
      </div>
    );
  };

  // Step 1 is always shown
  const generalInfoSection = (
    <>
      <Row>
        <Col md={4}>Kort beskrivning:</Col>
        <Col md={8}>{text.shortDesc || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Ref nr:</Col>
        <Col md={8}>{text.referensnummer || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Beställare:</Col>
        <Col md={8}>{text.clientContact || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Önskad starttid:</Col>
        <Col md={8}>
          {text.startTime ? text.startTime.replace("T", " ") : "-"}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Önskad sluttid:</Col>
        <Col md={8}>{text.endTime ? text.endTime.replace("T", " ") : "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Beställd produkt:</Col>
        <Col md={8}>{text.product || "-"}</Col>
      </Row>
    </>
  );

  // Step 2 - Customer information
  const customerInfoSection = (
    <>
      <Row>
        <Col md={4}>Namn:</Col>
        <Col md={8}>{text.customerName || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Telefon:</Col>
        <Col md={8}>{text.customerPhone || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.customerAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Postnummer och ort:</Col>
        <Col md={8}>
          {text.customerPostalcode || "-"} {text.customerCity || ""}
        </Col>
      </Row>
    </>
  );

  // Step 3 - Customer key information
  const customerKeySection = (
    <>
      <Row>
        <Col md={4}>Nyckel ID:</Col>
        <Col md={8}>{text.customerKeyID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.customerKeyAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Kontaktperson:</Col>
        <Col md={8}>{text.customerKeyName || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Telefon:</Col>
        <Col md={8}>{text.customerKeyPhone || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Ring för åtkomst/nyckel:</Col>
        <Col md={8}>{text.customerCallForAccess || "-"}</Col>
      </Row>
    </>
  );

  // Step 4 - Site details
  const siteDetailsSection = (
    <>
      <Row>
        <Col md={4}>Site ID:</Col>
        <Col md={8}>{text.siteID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.siteAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Postnummer och ort:</Col>
        <Col md={8}>
          {text.sitePostalcode || "-"} {text.siteCity || ""}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Våning:</Col>
        <Col md={8}>{text.siteFloor || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Rad/Stativ:</Col>
        <Col md={8}>{text.siteRow || "-"}</Col>
      </Row>
    </>
  );

  // Step 5 - Site access
  const siteAccessSection = (
    <>
      <Row>
        <Col md={4}>Nyckel ID:</Col>
        <Col md={8}>{text.accessSiteKeyID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.accessSiteAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Postnummer och ort:</Col>
        <Col md={8}>
          {text.accessSitePostalcode || "-"} {text.accessSiteCity || ""}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Namn:</Col>
        <Col md={8}>{text.accessSiteName || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Telefon:</Col>
        <Col md={8}>{text.accessSitePhone || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Ring för åtkomst/nyckel:</Col>
        <Col md={8}>{text.accessSiteCallForAccess || "-"}</Col>
      </Row>
    </>
  );

  // Step 6 - Equipment / Connection
  const equipmentSection = (
    <>
      <Row>
        <Col md={4}>Utrustnings ID:</Col>
        <Col md={8}>{text.equipmentID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Interface:</Col>
        <Col md={8}>{text.equipmentInterface || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Förbindelsenummer:</Col>
        <Col md={8}>{text.equipmentConnectionNumber || "-"}</Col>
      </Row>
    </>
  );

  // Step 7 - Material details
  const materialSection = (
    <>
      <Row>
        <Col md={4}>Krav på utrustning/instrument:</Col>
        <Col md={8}>{text.mtrlEquipment || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Reservdel 1:</Col>
        <Col md={8}>{text.sparePart1 || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Reservdel 2:</Col>
        <Col md={8}>{text.sparePart2 || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Reservdel 3:</Col>
        <Col md={8}>{text.sparePart3 || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Returhantering mtrl:</Col>
        <Col md={8}>{text.mtrlReturnMtrl || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Info returhantering:</Col>
        <Col md={8}>{text.infoMtrlReturnMtrl || "-"}</Col>
      </Row>
    </>
  );

  // Step 8 - Work description
  const workDescriptionSection = (
    <Row>
      <Col md={12}>
        {text.longWorkDesc || "Ingen arbetsbeskrivning angiven"}
      </Col>
    </Row>
  );

  return (
    <Container className="summaryContainer">
      <h4>Sammanfattning av din beställning</h4>

      {/* Step 1 - General info is always shown */}
      {renderSection("Grundläggande information", generalInfoSection, 1)}

      {/* Step 2 - Customer information */}
      {renderSection("Slutkund/Företag", customerInfoSection, 2)}

      {/* Step 3 - Customer key info */}
      {renderSection("Åtkomst slutkund/företag", customerKeySection, 3)}

      {/* Step 4 - Site details */}
      {renderSection("Site detaljer", siteDetailsSection, 4)}

      {/* Step 5 - Site access */}
      {renderSection("Tillträde site", siteAccessSection, 5)}

      {/* Step 6 - Equipment / Connection */}
      {renderSection("Utrustning / Avlämningspunkt", equipmentSection, 6)}

      {/* Step 7 - Material details */}
      {renderSection("Material detaljer", materialSection, 7)}

      {/* Step 8 - Work description is always shown */}
      {renderSection("Arbetsbeskrivning", workDescriptionSection, 8)}
    </Container>
  );
};

export default Step9;
